import { NewsItem } from "./types";

/**
 * Una news è "coming soon" se il flag è true E la counter_date è nel futuro.
 * Quando counter_date passa, isComingSoon torna false da solo:
 * la news ricompare in elenco e il dettaglio mostra il contenuto reale.
 */
export const isComingSoon = (item: NewsItem | undefined | null): boolean => {
    if (!item) return false;

    const flag = String(item.coming_soon ?? "").trim().toLowerCase();
    const isFlagged = flag === "true" || flag === "1" || flag === "yes";
    if (!isFlagged) return false;

    if (!item.counter_date) return false;
    const target = new Date(item.counter_date).getTime();
    if (Number.isNaN(target)) return false; // data malformata → non nascondiamo

    return target > Date.now();
};

/** Rimuove dalle liste pubbliche le news in coming soon. */
export const filterPublic = (items: NewsItem[]): NewsItem[] =>
    items.filter((item) => !isComingSoon(item));